<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Forum Post List</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <vue-good-table
                        ref="forumQuestionList"
                        mode="remote"
                        title="Forum Post List"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"
                        :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"

                        :search-options="{
                        enabled: false,
                        }">

                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="deleteQuestion()">Delete Post({{selectedRows}})</button>
                        </div>

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'question'">
                                    <span>{{props.row.question}}</span>
                                </div>
                                <div v-else-if="props.column.field == 'action'">
                                    <template v-if="props.row.status != 'Not-Approved'">
                                        <template v-if="props.row.is_pin_post">
                                            <a class="btn edit-btn-vvg waves-effect" title='Unpin Post' id="ping" v-on:click.prevent="changeQuestionPin(props.row.id)">
                                                <i class="fa fa-star-o" aria-hidden="true"></i>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a class="btn edit-btn-vvg waves-effect" title='Pin Post' id="ping" v-on:click.prevent="changeQuestionPin(props.row.id)">
                                                <i class="fa fa-star" aria-hidden="true"></i>
                                            </a>
                                        </template>
                                    </template>
                                    <router-link class="btn edit-btn-vvg waves-effect" v-show="props.row.question_image_count > 0" :to="{ name: 'ListForumQuestionImages', params: { id: props.row.id }}">
                                        <i class="fa fa-picture-o" aria-hidden="true"></i>
                                    </router-link>
                                    <!-- <a class="btn edit-btn-vvg waves-effect"  v-show="props.row.question_image_count <= 0">
                                        <i style="opacity: 0;" class="fa fa-picture-o" aria-hidden="true"></i>
                                    </a> -->
                                    <template v-if="props.row.status == 'Not-Approved'">
                                        <a class="btn edit-btn-vvg waves-effect" title='Approve Post' id="approveQuestion" v-on:click.prevent="changeQuestionStatus(props.row.id)">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </a>
                                        <a class="btn edit-btn-vvg waves-effect" title='Decline Post' id="declineQuestion" v-on:click.prevent="deleteQuestion(props.row.id)">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </a>
                                    </template>
                                    <template v-else>
                                        <a class="btn edit-btn-vvg waves-effect" title='Delete Post' id="delete" v-on:click.prevent="deleteQuestion(props.row.id)">
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                        </a>
                                        <template v-if="props.row.question_comment_count != '0'">
                                            <a class="btn edit-btn-vvg waves-effect" title='Available Comments' id="availableComment" v-on:click.prevent="listComments(props.row.id)">
                                                <strong>{{props.row.question_comment_count}}</strong>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a class="btn edit-btn-vvg waves-effect" title='Available Comments' id="availableComment">
                                                <strong>{{props.row.question_comment_count}}</strong>
                                            </a>
                                        </template>
                                    </template>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>

                    </vue-good-table>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    var self;
    export default {
        name: 'ListForumQuestions',
        components: {
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                error: '',
                exportUsers: false,
                modelTitle: '',
                modelButtonId: '',
                subject: '',
                subjectError: '',
                message: '',
                messageError: '',
                filesAttachment: [],
                firstLoad: 0,
                columns: [
                    {
                        label: 'Post',
                        field: 'question',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Post", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created By',
                        field: 'created_by',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Created By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        width: '192px',
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.showLoader();
            self.loadQuestions();
        },
        methods: {
            listComments(id) {
                self.$router.push('/backend/forum-comments/' + id);
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadQuestions();
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadQuestions();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('question');
                    field: ('is_active');
                    field: ('status');
                    field: ('created_by');
                    field: ('approved_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.question || filters.is_active || filters.status || filters.created_by || filters.approved_by) {
                    self.loadQuestions();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['forumQuestionList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadQuestions();
            },
            deleteQuestion: function (id) {
                var questionArr = [];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                if (id) {
                    questionArr.push(id);
                } else {
                    var selectedQuestion = self.$refs['forumQuestionList'].selectedRows;
                    for (var i = 0; i < selectedQuestion.length; i++) {
                        questionArr.push(this.$refs['forumQuestionList'].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteArr: questionArr,
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("deletequestions", fields, config)
                                .then(function (response) {
                                    self.loadQuestions();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal({
                            title: 'Deleted',
                            type: 'success',
                            text: 'You successfully deleted the record(s).',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            text: 'Your record(s) still intact',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                })
            },
            changeQuestionStatus: function (id) {
                var questionArr = [];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                if (id) {
                    questionArr.push(id);
                } else {
                    var selectedQuestion = self.$refs['forumQuestionList'].selectedRows;
                    for (var i = 0; i < selectedQuestion.length; i++) {
                        questionArr.push(this.$refs['forumQuestionList'].selectedRows[i].id);
                    }
                }
                var fields = {
                    questionArr: questionArr,
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your status change action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Change it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("changequestionstatus", fields, config)
                                .then(function (response) {
                                    self.loadQuestions();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal({
                            title: 'Changed',
                            type: 'success',
                            text: 'You successfully changed status of the record(s).',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            text: 'Your record(s) still intact',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                })
            },
            changeQuestionPin: function(id) {
                var pinArr = [];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                if (id) {
                    pinArr.push(id);
                } else {
                    var selectedQuestion = self.$refs['forumQuestionList'].selectedRows;
                    for (var i = 0; i < selectedQuestion.length; i++) {
                        pinArr.push(this.$refs['forumQuestionList'].selectedRows[i].id);
                    }
                }
                console.log(pinArr);
                var fields = {
                    pinArr: pinArr,
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your pin change action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Change it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("changequestionpin", fields, config)
                                .then(function (response) {
                                    self.loadQuestions();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            text: 'Your record(s) still intact',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                });
            },
            loadQuestions: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                self.showLoader();
                HTTP.post('listquestions', fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        }
                        self.hideLoader();
                    })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/forum/ListForumQuestions.vue